import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { AddDeliveryPopup } from "../../component/addDeliveryPopup ";
import Button from "../../../../widgets/button";

interface editRowProps {
  data: any;
  context: any;
  totalDeliveredCount: any;
}
interface editRowStateProps {
  modal: boolean;
  isEdit: boolean;
  editData: any;
  deleteModal: boolean;
}
export class ActionRow extends Component<editRowProps, editRowStateProps> {
  childRef: any;

  constructor(props: editRowProps) {
    super(props);
    this.state = {
      modal: false,
      isEdit: false,
      editData: {},
      deleteModal: false,
    };
    this.childRef = React.createRef();
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
    if (this.state.modal === false) {
      this.childRef.current.getDeliveryDetail();
    }
  };
  refresh = () => {
    this.props.context.componentParent.getDeliveryList();
  };
  changeStatus = () => {
    this.props.context.componentParent.changeStatusHandler(this.props.data);
  };

  deleteToggle = () => {
    this.setState({
      deleteModal: !this.state.deleteModal,
    });
  };

  closeBtn = (
    <button className="close" title="Close" onClick={this.deleteToggle}>
      &times;
    </button>
  );
  render() {
    return (
      <>
        <AddDeliveryPopup
          totalQuantity={{
            totalProcured: this.props.data.procuredQuantity,
            totalReceived: this.props.totalDeliveredCount,
            currentDeliveredValue: this.props.data.DeliveryQuantity,
          }}
          isEdit={true}
          modal={this.state.modal}
          toggle={this.toggle}
          deliveryId={this.props.data.id}
          procurementId={this.props.data.procurementId}
          ref={this.childRef}
          refresh={this.refresh}
        />
        <Modal isOpen={this.state.deleteModal} toggle={this.deleteToggle}>
          <ModalHeader
            className="modal_Bg"
            toggle={this.deleteToggle}
            close={this.closeBtn}
          >
            <div className="modal_title"> Confirmation Alert</div>
          </ModalHeader>
          <ModalBody>Are you sure to Delete?</ModalBody>
          <ModalFooter>
            <Button
              label="No"
              className="ml-2 btn btn-outline-secondary"
              onClick={this.deleteToggle}
            />
            <Button
              label="Yes"
              className="ml-2 btn btn-theme-primary"
              onClick={this.changeStatus}
            />
          </ModalFooter>
        </Modal>
        <button
          className="Action_btn"
          onClick={() => this.toggle()}
          title="Edit"
        >
          <i className="bi bi-pencil-square"></i>
        </button>

        <button
          onClick={() => this.deleteToggle()}
          title="Delete"
          className="Action_btn"
          style={{ marginLeft: "16px" }}
        >
          <i className="bi bi-trash"></i>
        </button>
      </>
    );
  }
}
